import React from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography
} from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

export default function ConfirmDialog({ open, title = '¿Confirmar acción?', message, onConfirm, onCancel }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon sx={{ color: 'warning.main' }} />
        {title}
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} variant="outlined">No</Button>
        <Button onClick={onConfirm} variant="contained" color="error">Sí, confirmar</Button>
      </DialogActions>
    </Dialog>
  )
}
